import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import customerActions from "../../Actions/customerActions";
import useModal from "../../Hooks/useModal";
import Modals from "../../Constants/modals";

import CompensationVbProducts from "../../Components/Customer/Compensation/CompensationVbProducts";
import CompensationBlikkProducts from "../../Components/Customer/Compensation/CompensationBlikkProducts";
import { DefaultCard } from "../../Components/Card/Card";
import CompensationFormModal from "../../Components/Customer/Modals/CompensationFormModal";

import { useTranslation } from "react-i18next";
import CompensationVossSubscriptions from "../../Components/Customer/Compensation/CompensationVossSubscriptions";
import { VossSubscriptionItemStatus } from "../../Constants/VOSS/vossSubscriptionItemStatus";
import subscriptionUtils from "../../Utils/subscriptionUtils";
import useFeatureFlags from "../../Hooks/useFeatureFlags";
import { FeatureFlags } from "../../Utils/featureFlags";
import CompensationHistory from "../../Components/Customer/Compensation/CompensationHistory";

export default function CompensationContainer() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { openModal, isModalOpen } = useModal();

    const customer = useSelector(state => state.CustomerReducer.customer.vossCustomer ?? state.CustomerReducer.customer.vbCustomer);
    const { customerNumber, id } = customer;

    const {
        customerCompensations,
        blikkProducts,
        vonProducts,
        vbProducts,
        subscriptions
    } = useSelector(state => state.CustomerReducer);

    const [selectedProduct, setSelectedProduct] = useState(null);

    const compensatableSubscriptions = useMemo(() => {
        return subscriptions?.filter(sub => sub.status === VossSubscriptionItemStatus.Active && !subscriptionUtils.hasEvergreenBindingPeriod(sub) && !subscriptionUtils.hasEvergreenBillingPeriod(sub)) || [];
    }, [subscriptions]);

    const isLoading = useSelector(state => [
        state.CustomerReducer.dataLoading.blikkData,
        state.CommonReducer.dataLoading.vonProducts,
        state.CommonReducer.dataLoading.vbProducts,
        state.CommonReducer.dataLoading.subscriptions,
        state.CommonReducer.dataLoading.customerCompensations
    ].some(Boolean));
    
    useEffect(() => {
        if (!customerCompensations)
            dispatch(customerActions.getCompensationsForCustomer(customerNumber));

        if (!blikkProducts)
            dispatch(customerActions.getBlikkProducts(customerNumber));

        if (!vbProducts)
            dispatch(customerActions.getCustomerVBProducts(customerNumber));

        if (!subscriptions)
            dispatch(customerActions.searchSubscriptions(id));
    }, []);

    const onOpenModal = (product) => {
        setSelectedProduct(product);
        openModal(Modals.CompensationModal);
    };

    return (
        <>
            <DefaultCard title={t("compensationcontainer.compensation")} isLoading={isLoading}>
                <div>
                    {compensatableSubscriptions.length > 0 && (
                        <CompensationVossSubscriptions subscriptions={compensatableSubscriptions} onClick={onOpenModal} />
                    )}
                    {vbProducts?.length > 0 && (
                        <CompensationVbProducts products={vbProducts} onClick={onOpenModal} />
                    )}
                    {blikkProducts?.length > 0 && (
                        <CompensationBlikkProducts products={blikkProducts} onClick={onOpenModal} />
                    )}
                    <CompensationHistory compensations={customerCompensations} />
                </div>
            </DefaultCard>
            {isModalOpen(Modals.CompensationModal) && (
                <CompensationFormModal product={selectedProduct} />
            )}
        </>
    );
}
